import { syntheticShortIds } from './constants';

export function isAutomatedUser(shortId?: string): boolean {
  return syntheticShortIds.includes(shortId ?? '');
}
